"use client";

import * as React from "react";
import { Eye, EyeOff } from "lucide-react";
import { UnderlineInput } from "./UnderlineInput";
import { cn } from "@/lib/utils";

export interface PasswordInputProps
  extends Omit<React.InputHTMLAttributes<HTMLInputElement>, "type"> {
  icon?: React.ReactNode;
  error?: boolean;
}

const PasswordInput = React.forwardRef<HTMLInputElement, PasswordInputProps>(
  ({ className, icon, error, ...props }, ref) => {
    const [showPassword, setShowPassword] = React.useState(false);
    return (
      <div className="relative w-full">
        <UnderlineInput
          ref={ref}
          type={showPassword ? "text" : "password"}
          icon={icon}
          error={error}
          className={cn("pr-10", className)}
          {...props}
        />
        <button
          type="button"
          aria-label={showPassword ? "Hide password" : "Show password"}
          className="absolute right-0 top-1/2 -translate-y-1/2 p-2 text-[var(--iris-text-muted)] hover:text-white"
          onClick={() => setShowPassword((p) => !p)}
        >
          {showPassword ? (
            <EyeOff className="h-4 w-4" />
          ) : (
            <Eye className="h-4 w-4" />
          )}
        </button>
      </div>
    );
  }
);
PasswordInput.displayName = "PasswordInput";

export { PasswordInput };
